import { render } from "./Kpi.vue?vue&type=template&id=b3084880&ts=true"
import script from "./Kpi.vue?vue&type=script&lang=ts"
export * from "./Kpi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__